import AppShell from "@/components/layout/AppShell";
import { ProfessionalDevelopmentHub } from "@/components/staff-reports/ProfessionalDevelopmentHub";
import { useAuth } from "@/contexts/AuthContext";

const PRIMARY_OWNER_EMAIL = "todayskidz@comcast.net";

const CAN_EDIT_ROLES = ["owner", "co-owner", "business-manager", "director", "assistant_director", "group_supervisor", "supervisor"];

const ProfessionalDevelopmentHubPage = () => {
  const { user } = useAuth();

  const canEdit =
    user?.email === PRIMARY_OWNER_EMAIL ||
    CAN_EDIT_ROLES.includes(user?.role?.toLowerCase());

  return (
    <AppShell pageTitle="Professional Development Hub" breadcrumb>
      <div className="p-4 md:p-6 max-w-7xl mx-auto">
        <ProfessionalDevelopmentHub isOwner={canEdit} />
      </div>
    </AppShell>
  );
};

export default ProfessionalDevelopmentHubPage;
